<template>
    <div class="table" :class="{'--zebraColumns': isZebraStyle}">
        <zTableHeader :columns="columns" :rowStyle="rowStyle"
                     @sortBy="sortBy($event)"
                     v-slot:="{column}">
            <span v-if="isSourceType">
                <img :src="column.sourceIconUrl" class="headerSourceIcon">
                {{ column.name }}</span>
        </zTableHeader>
        
        <zTableRow v-for="row in data" :key="row.id"
                  v-bind="{ data: row, columns, columnsNameMap, rowStyle }"
                  @onNameClick="$emit('onNameClick', $event)"
                  @onInfoClick="$emit('onInfoClick', $event)">
            <template v-if="isSourceType" v-slot:default="{source}">
                <span v-if="source === undefined" style="color: #ccc; cursor: default">
                    {{ gettext('н/д') }}
                    <span class="positionChange" style="visibility:hidden"></span>
                </span>
                
                <Tooltip :content="positionInfoTooltip" placement="bottom-start" v-if="source !== undefined">
                    <span @click="$emit('onPositionInfoClick', $event, source)">
                        <span v-if="source.position === null">
                            --
                            <span class="positionChange" style="visibility:hidden"></span>
                        </span>
                    
                        <span v-if="source.position !== null">
                            {{ source.position }}
                            <span class="positionChange" :style="{'visibility': source.change === 0 || source.change === null ? 'hidden' : 'visible'}">
                                <i class="positionChange__up fa fa-arrow-up" v-if="source.change === 0"></i> <!-- TODO Хардкод -->
                                <i class="positionChange__up fa fa-arrow-up" v-if="source.change > 0"></i>
                                <i class="positionChange__down fa fa-arrow-down" v-if="source.change < 0"></i>
                                <span class="positionChange__value">{{ source.change }}</span>
                            </span>
                        </span>
                    </span>
                </Tooltip>
            </template>
        </zTableRow>
    </div>
</template>

<script>
import zTableHeader from "@/3_view/core/zTableHeader";
import zTableRow from "@/3_view/core/zTableRow";
import {Tooltip} from "view-design";
import Vue from 'vue'

Vue.component('Tooltip', Tooltip);

export default {
    name: 'zTable',
    components: {
        zTableHeader, zTableRow,
    },
    props: {
        data: Array,
        columns: Array,
        columnsNameMap: Object,
        type: String,
        rowStyle: Object,
        isZebraStyle: Boolean,
        cellMinWidth: String,
        positionInfoTooltip: String,
    },
    computed: {
        isSourceType() {
            return this.type === 'source'
        },
    },
    methods: {
        /**
         * @param column
         * @param propertyPath - можно описать путь к значению 'a.b.c'
         */
        // sortBy(column, propertyPath = '') {
        //     if (this.isSourceType) propertyPath = 'position' // TODO Хардкод
        //
        //     let key = propertyPath ? column.name + '.' + propertyPath : this.columnsNameMap ? this.columnsNameMap[column.name] : column.name
        //     column.isAscSort = !column.isAscSort
        //
        //     if (this.isSourceType) { // TODO Хардкод
        //         this.data.sort((a, b) => {
        //             return column.isAscSort ? a[column.name].position - b[column.name].position : b[column.name].position - a[column.name].position
        //         })
        //     }
        //
        //     if (isStringColumn(column)) {
        //         sortByString(this.data, key, column.isAscSort)
        //     }
        //     else if (isNumberColumn(column)) {
        //         sortObjectsByNumber(this.data, key, column.isAscSort)
        //     }
        //
        //     column.isSort = true // TODO Доработать. Синхрон в TableGroup
        // },
        
        sortBy(column) {
            column.isAscSort = !column.isAscSort
            this.$emit('sort', { sortingKey: column.sortingKey, isAscSort: column.isAscSort })
        }
    },
}


</script>

<style lang="less">
@c-active: #4297FB;

.table {
    display: flex;
    flex-flow: column;
    flex-basis: 100%;
}

.table.--zebraColumns {
    .tableRow:not(.tableHeader) > *:nth-of-type(2n-1) {
        background: #f7f7f7
    }
}

.tableHeader {
    &.tableRow {
        border: none;
        color: #777;
        line-height: 3.1;
    }
}

.tableRow {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    border-bottom: 1px solid #ddd;
    height: 40px;
    font-size: 1.4em;
    .tableCell {
        padding: 0 1.2em;
        overflow: hidden;
        white-space: nowrap;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        &:first-of-type {
            padding-left: 0;
        }
        .infoIcon {
            cursor: pointer;
            cursor: pointer;
            font-size: 0.7em;
            color: #777;
            vertical-align: super;
            padding: 4px;
        }
        .tableCell__content.--clickable {
            cursor: pointer;
            user-select: none;
            &:hover {
                color: @c-active
            }
        }
    }
}

.tableRow > *:nth-of-type(n+2) {
    border-left: 1px solid transparent;
}

.tableRow:last-of-type {
    border-bottom-width: 1px;
}

.tableRow:not(.tableHeader):not(.selected):hover {
    //background: #f5f6fa;
}

.tableRow.selected {
    background: #a3d8c5;
}

.tableCell.numberFormat {
    justify-content: flex-end;
}
</style>